module.exports = __webpack_public_path__ + "assets/img/topImg4.37e7d5c8.png";